import React from "react";

const UnisexHairSalonNearMeCustomer = () => {
  return (
    <div className="hairSalonNearMeCustomer">
      <h5>
        Client Testimonials: Why SCENT is the Best Unisex Hair Salon Near Me
      </h5>
      <p>
        Our satisfied clients rave about SCENT’s outstanding services. Here’s
        what some of them have to say about their experience:
      </p>
      <div className="hairSalonNearMeCustomerContent">
        <p>
          <span className="quote">“</span>I was looking for a high-quality
          unisex hair salon near me, and I’m so glad I found SCENT. The team is
          fantastic, and I love my new haircut!
          <span className="quote">”</span> - <span>Shreya</span>
        </p>
        <p>
          <span className="quote">“</span>SCENT is my go-to unisex hair salon
          near me for both my haircut and beard grooming. The stylists are
          highly skilled, and I always leave looking sharp
          <span className="quote">”</span> - <span>Rajesh </span>
        </p>
        <p>
          <span className="quote">“</span>I’ve been coming to SCENT for years,
          and the service is consistently excellent. It’s the best unisex hair
          salon near me by far!
          <span className="quote">”</span> - <span> Anjali</span>
        </p>
      </div>
    </div>
  );
};

export default UnisexHairSalonNearMeCustomer;
